export default __webpack_public_path__ + "static/media/art_btn.ff84b16a777770083c4258357272b4ae.svg";